import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import { isFreelanceLeague } from '@maxpreps/shared/functions/utils/leagueUtils';
import THEME from '@maxpreps/shared/styles/colors';
import React from 'react';
import RecordDetailsBox from './RecordDetailsBox';
import RecordLeagueData from './RecordLeagueData';
import RecordSummaryBox from './RecordSummaryBox';
import {
  StyledDetailsBoxContainer,
  StyledDetailsBoxContainerWrapper,
  StyledRecordCard,
  StyledSummaryBoxContainer
} from './StyledRecordCard';
import WinPercentage from './WinPercentage';

export interface IRecordCardProps {
  overallRecord: string;
  leagueRecord?: string;
  overallWinPercentage: number;
  leagueStandingPlacement?: string;
  leagueWinPercentage?: number;
  homeRecord: string;
  awayRecord: string;
  neutralRecord: string;
  pf: string | number;
  pa: string | number;
  streak: number;
  streakResult?: string;
  leagueCanonicalUrl?: string;
}

const RecordCard: React.FC<IRecordCardProps> = ({
  overallRecord = '0-0',
  leagueRecord = '0-0',
  overallWinPercentage = 0,
  leagueStandingPlacement,
  leagueWinPercentage = 0,
  leagueCanonicalUrl,
  homeRecord = '0-0',
  awayRecord = '0-0',
  neutralRecord = '0-0',
  pf = 0,
  pa = 0,
  streak = 0,
  streakResult
}) => {
  const teamContext = useTeamContext();

  const { data } = teamContext;
  const { leagueName } = data;
  const { leagueAlias } = teamContext.stateData;

  const isFreelance = isFreelanceLeague(leagueName);

  const leftDetails = [
    { label: 'HOME', value: homeRecord },
    { label: 'AWAY', value: awayRecord },
    { label: 'NEUTRAL', value: neutralRecord }
  ];

  const streakText = !streak ? '-' : `${streak}${streakResult}`;
  const streakColor = streakText?.includes('W')
    ? THEME.status.positive
    : streakText?.includes('L')
    ? THEME.status.negative
    : 'unset';

  const rightDetails = [
    { label: 'PF', value: pf },
    { label: 'PA', value: pa },
    {
      label: 'STREAK',
      value: streakText,
      color: streakColor
    }
  ];

  return (
    <StyledRecordCard>
      <StyledSummaryBoxContainer>
        <RecordSummaryBox type="OVERALL" record={overallRecord}>
          <WinPercentage winningPercentage={overallWinPercentage} />
        </RecordSummaryBox>
        <RecordSummaryBox
          type={leagueAlias.toUpperCase()}
          record={isFreelance ? '-' : leagueRecord}
        >
          <RecordLeagueData
            leagueStandingPlacement={leagueStandingPlacement}
            leagueWinPercentage={leagueWinPercentage}
            leagueCanonicalUrl={leagueCanonicalUrl}
          />
        </RecordSummaryBox>
      </StyledSummaryBoxContainer>
      <StyledDetailsBoxContainerWrapper>
        <StyledDetailsBoxContainer>
          <RecordDetailsBox rows={leftDetails} />
          <RecordDetailsBox rows={rightDetails} />
        </StyledDetailsBoxContainer>
      </StyledDetailsBoxContainerWrapper>
    </StyledRecordCard>
  );
};

export default RecordCard;
